import { render, staticRenderFns } from "./SiteAbout.vue?vue&type=template&id=a239d91c&scoped=true&"
var script = {}
import style0 from "./SiteAbout.vue?vue&type=style&index=0&id=a239d91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239d91c",
  null
  
)

export default component.exports